import * as React from 'react';

// API
import apibridge from '../../apibridge';

// UTILS
import { validationErrorsToString } from '../../utils';
import { useUpdateTotalNotification } from '../../utils/useUpdateTotalNotification';

// PACKAGES
import { useHistory } from 'react-router';
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// COMPONENTS
import Button from '../../components/Button';
import LoadingSpinner from '../../components/LoadingSpinner';

// ICONS
import { ReactComponent as AlertIcon } from '../../assets/svg/alert.svg';

import { closeModalType } from '../../components/GlobalModal';

interface ApproveModalTypes {
	isVolunteer?: boolean;
	id?: string;
	firstName?: string;
	lastName?: string;
	closeModal?: closeModalType;
	confirmedIdentity: boolean;
}

const ApproveModal: React.FC<ApproveModalTypes> = ({
	closeModal,
	isVolunteer,
	id,
	firstName,
	lastName,
	confirmedIdentity
}) => {
	const history = useHistory();

	// Error and Loading state
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');

	const [isLoading, setIsLoading] = React.useState<boolean>(false);

	const confirmApprove = async () => {
		setIsLoading(true);

		if (confirmedIdentity) {
			if (isVolunteer) {
				const response = await apibridge.postRequestsToJoinVolunteerApprove({
					userProfileId: id
				});

				if (response.isError) {
					setIsLoading(false);

					setFormErrorMessage(
						response.validationErrors.length
							? validationErrorsToString(response.validationErrors)
							: response.message || 'An error has occurred'
					);
				} else {
					useUpdateTotalNotification();

					setIsLoading(false);

					history.push('/requests-to-join');
				}
			} else {
				const response = await apibridge.approveRequestsToJoin({
					profileId: id
				});

				if (response.isError) {
					setIsLoading(false);

					setFormErrorMessage(
						response.validationErrors.length
							? validationErrorsToString(response.validationErrors)
							: response.message || 'An error has occurred'
					);
				} else {
					useUpdateTotalNotification();

					setIsLoading(false);

					history.push('/requests-to-join');
				}
			}
		} else {
			return;
		}
	};

	return (
		<div className="modal-confirmation">
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<>
								<figure className="icon">
									<AlertIcon />
								</figure>

								<h2 className="heading h4">
									Are you sure you wish to approve{' '}
									<strong className="text-capitalized">
										'{firstName} {lastName}'
									</strong>
								</h2>

								<section className="actions">
									<Button className="btn-primary full-width" onClick={confirmApprove}>
										Yes
									</Button>

									<Button className="btn-secondary full-width" onClick={closeModal}>
										Cancel
									</Button>
								</section>
							</>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</div>
	);
};

export default ApproveModal;
